import { Alert, AppBar, Box, Container, IconButton, Toolbar, Typography } from "@mui/material";
import {
    Add as AddIcon,
    Code as CodeIcon,
    MenuBook as MenuBookIcon,
    Logout as LogoutIcon,
    Search as SearchIcon,
    Assignment as AssignmentIcon,
    Home as HomeIcon,
    Timer as TimerIcon,
    Settings as SettingsIcon
  } from '@mui/icons-material';
import { useAuth } from "../contexts/AuthContext";
import { useState } from "react";
import TryCodingPanel from "./TryCodingPanel";
import UserSettingsDialog from "./UserSettingsDialog";

export default function CustomAppBar({ children, sx, appBarSx, containerSx }) {
    const { user, logout } = useAuth();
    const [tryCodingOpen, setTryCodingOpen] = useState(false);
    const [settingsOpen, setSettingsOpen] = useState(false);

    const handleLogout = () => {
        logout();
      };

    const goHome = () => {
        window.location.href = '/subjects';
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: 'background.default', ...sx }}>
            <AppBar position="sticky" elevation={0} sx={{ borderRadius: 0, pt: 'env(safe-area-inset-top, 0px)', pl: 'env(safe-area-inset-left, 0px)', pr: 'env(safe-area-inset-right, 0px)', ...appBarSx }}>
                <Toolbar sx={{ px: { xs: 1.5, md: 4 }, minHeight: { xs: 56, sm: 64 } }}>
                    <Box 
                        onClick={goHome}
                        sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, cursor: 'pointer', overflow: 'hidden', mr: 1 }}
                    >
                        <MenuBookIcon sx={{ mr: { xs: 1, sm: 2 }, fontSize: { xs: 24, sm: 28 }, flexShrink: 0 }} />
                        <Typography variant="h5" component="div" sx={{ fontWeight: 700, letterSpacing: '-0.5px', fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.5rem' }, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            The Revision App
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, sm: 1, md: 2 } }}>
                        <Box sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center', gap: 1, px: 2, py: 1, bgcolor: 'rgba(255,255,255,0.1)', borderRadius: 2 }}>
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                Welcome, {user?.username}!
                            </Typography>
                        </Box>
                        <IconButton
                            color="inherit"
                            onClick={goHome}
                            sx={{
                                bgcolor: 'rgba(255,255,255,0.1)',
                                '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' },
                                p: { xs: 0.75, sm: 1 }
                            }}
                            title="Home"
                        >
                            <HomeIcon />
                        </IconButton>
                        <IconButton
                            color="inherit"
                            onClick={() => window.location.href = '/tests'}
                            sx={{
                                bgcolor: 'rgba(255,255,255,0.1)',
                                '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' },
                                p: { xs: 0.75, sm: 1 }
                            }}
                            title="Test History"
                        >
                            <AssignmentIcon />
                        </IconButton>
                        <IconButton
                            color="inherit"
                            onClick={() => window.location.href = '/timer'}
                            sx={{
                                bgcolor: 'rgba(255,255,255,0.1)',
                                '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' },
                                p: { xs: 0.75, sm: 1 }
                            }}
                            title="Pomodoro Timer"
                        >
                            <TimerIcon />
                        </IconButton>
                        <IconButton
                            color="inherit"
                            onClick={() => setTryCodingOpen(true)}
                            sx={{
                                bgcolor: 'rgba(255,255,255,0.1)',
                                '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' },
                                p: { xs: 0.75, sm: 1 }
                            }}
                            title="Try Coding"
                        >
                            <CodeIcon />
                        </IconButton>
                        <IconButton
                            color="inherit"
                            onClick={() => setSettingsOpen(true)}
                            sx={{
                                bgcolor: 'rgba(255,255,255,0.1)',
                                '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' },
                                p: { xs: 0.75, sm: 1 }
                            }}
                            title="Account Settings & Preferences"
                        >
                            <SettingsIcon />
                        </IconButton>
                        <IconButton
                            color="inherit"
                            onClick={handleLogout}
                            sx={{
                                bgcolor: 'rgba(255,255,255,0.1)',
                                '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' },
                                p: { xs: 0.75, sm: 1 }
                            }}
                            title="Logout"
                        >
                            <LogoutIcon />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>

            <Container maxWidth="xl" sx={{ flexGrow: 1, py: { xs: 2.5, md: 4 }, px: { xs: 2, md: 4 }, pb: { xs: 'calc(24px + env(safe-area-inset-bottom, 0px))', md: 4 }, ...containerSx }}>
                {children}
            </Container>

            {/* Try Coding Panel */}
            <TryCodingPanel
                open={tryCodingOpen}
                onClose={() => setTryCodingOpen(false)}
            />

            {/* User Settings Dialog */}
            <UserSettingsDialog
                open={settingsOpen}
                onClose={() => setSettingsOpen(false)}
            />
        </Box>
    )
}